import { Injectable } from '@angular/core';
import { NotificationComponent } from '../../../shared/components/notification/notification/notification.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  public showErrorNotification(message: string): void {
    this.snackBar.openFromComponent(NotificationComponent, {
      data: message,
      duration: 5000,
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
  }

  public showSuccessNotification(message: string): void {
    this.snackBar.openFromComponent(NotificationComponent, {
      data: message,
      duration: 5000,
      panelClass: 'success',
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
  }
}
